import React, { useState, useEffect } from "react";
import axios from "axios";
import { FaEdit, FaSave } from "react-icons/fa";
import {
    getDeliveryBillingAPI,
    saveOrUpdateDeliveryBillingAPI,
} from "../../../Servicefile/SettingsAndControlService.jsx";
const DeliveryBillingcharges = () => {

    const promotionFields = [
        { label: "Approach Fee Charge ", key: "approachFeePerKm" },
        { label: "Delivery Fee Charge ", key: "deliveryFeePerKm" },
        { label: "Maximum Distance K/M ", key: "maxDistanceKm" },

    ];

    const [data, setData] = useState({});
    const [editMode, setEditMode] = useState({});

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const result = await getDeliveryBillingAPI();

            setData(result || {});
        } catch (err) {
            console.error(err);
        }
    };

    const toggleEdit = (key) => {
        setEditMode(prev => ({ ...prev, [key]: !prev[key] }));
    };

    const handleChange = (key, value) => {
        setData(prev => ({
            ...prev,
            [key]: value
        }));
    };

    const handleSave = async (key) => {
        try {
            await saveOrUpdateDeliveryBillingAPI(
                data,
                key
            );

            toggleEdit(key);

            fetchData();

        } catch (err) {
            console.error(err);

            alert("Failed to save");
        }
    };

    const renderTable = () => (
        <div style={{
            marginTop: '10px',
            border: '1px solid #ddd',
            borderRadius: '4px',
            overflow: 'hidden',
            maxHeight: '450px'
        }}>

            <div style={{ maxHeight: "400px", overflowY: "auto" }}>
                <table style={{ width: "100%", borderCollapse: "collapse" }}>

                    {/* ✅ HEADER */}
                    <thead style={{ position: "sticky", top: 0, zIndex: 1 }}>
                        <tr>
                            <th style={{ ...headerStyle, width: "50%" }}>Charge Type</th>
                            <th style={{ ...headerStyle, width: "25%" }}>Value</th>
                            <th style={{ ...headerStyle, width: "25%" }}>Actions</th>
                        </tr>
                    </thead>

                    {/* ✅ BODY */}
                    <tbody>
                        {promotionFields.map(({ label, key }, index) => (
                            <tr key={key} style={{
                                backgroundColor: index % 2 === 0 ? "#f9f9f9" : "#ffffff"
                            }}>
                                <td style={{ ...cellStyle, width: "50%" }}>
                                    <strong>{label}</strong>
                                </td>

                                <td style={{ ...cellStyle, width: "25%" }}>
                                    {editMode[key] ? (
                                        <input
                                            type="number"
                                            value={data[key] ?? ""}
                                            onChange={(e) => handleChange(key, e.target.value)}
                                            style={inputStyle}
                                        />
                                    ) : (
                                        <span>{data[key] ?? "—"}</span>
                                    )}
                                </td>

                                <td style={{ ...cellStyle, width: "25%" }}>
                                    {editMode[key] ? (
                                        <FaSave
                                            onClick={() => handleSave(key)}
                                            style={{ ...iconStyle, color: "#4caf50" }}
                                        />
                                    ) : (
                                        <FaEdit
                                            onClick={() => toggleEdit(key)}
                                            style={iconStyle}
                                        />
                                    )}
                                </td>
                            </tr>
                        ))}
                    </tbody>

                </table>
            </div>
        </div>


    );

    return (
        <div >
            {renderTable()}
        </div>
    );
};

const headerStyle = {
    background: "rgb(230 109 51)",
    color: "#fff",
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center"
};

const cellStyle = {
    padding: "12px",
    border: "1px solid #ddd",
    textAlign: "center"
};

const inputStyle = {
    width: "90px",
    padding: "5px",
    border: "1px solid #ccc",
    borderRadius: "5px",
    textAlign: "center"
};

const iconStyle = {
    fontSize: "20px",
    cursor: "pointer"
};

export default DeliveryBillingcharges;